import React from 'react';
import { History } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { Grid } from '@mui/material';
import PropTypes from 'prop-types';
import OfferHistoryComponent from './OfferHistoryComponent';
import DisclaimerComponent from '../../components/DisclaimerComponent';
import { Card, FakeText } from '@totalsoft/rocket-ui';
import { Table, Thead, Tbody, Tr, Th } from 'react-super-responsive-table';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';
import { OfferHistoryTableContainer } from './OfferHistoryStyles';

const OfferHistoryCard = ({ loading, offersHistory }) => {
  const { t } = useTranslation();

  return (
    <Card id='OffersHistoryComponent_IconCard' icon={History} title={t('Offer.Edit.OffersHistory.Header.Title')}>
      <Grid container alignItems='flex-start'>
        <OfferHistoryTableContainer item xs={12}>
          <Table>
            <Thead>
              <Tr>
                <Th>{t('Offer.Edit.OffersHistory.Header.Insurer')}</Th>
                <Th>{t('Offer.Edit.OffersHistory.Header.RequestedBy')}</Th>
                <Th>{t('Offer.Edit.OffersHistory.Header.OfferDate')}</Th>
                <Th>{t('Offer.Edit.OffersHistory.Header.InsuranceAmount')}</Th>
                <Th>{t('Offer.Edit.OffersHistory.Header.InsurerErrors')}</Th>
              </Tr>
            </Thead>
            <Tbody>
              {!loading &&
                offersHistory.map((offer, index) => {
                  return <OfferHistoryComponent key={index} offer={offer} />;
                })}
            </Tbody>
          </Table>
          {loading && <FakeText lines={10} />}
        </OfferHistoryTableContainer>
        <DisclaimerComponent />
      </Grid>
    </Card>
  );
};

OfferHistoryCard.propTypes = {
  loading: PropTypes.bool.isRequired,
  offersHistory: PropTypes.array
};

export default OfferHistoryCard;
